/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function asUrlList(value: any): string[] {
  if (!value) {
    return [];
  }
  if (_.isArray(value)) {
    return value;
  }
  if (_.isObject(value)) {
    return _.values(value) as string[];
  }
  return [];
}

export function asUrlGroupList(value: any): string[][] {
  if (!value) {
    return [];
  }
  const groups = _.isArray(value) ? value : _.values(value);
  return _.map(groups, (group) => asUrlList(group));
}
